import { SetsService } from '@app/sets/services/sets.service';
import {
    animate,
    state,
    style,
    transition,
    trigger,
} from '@angular/animations';
import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
    ISetVariantsImage,
    IVariantGridData,
    IVariantImageModelData,
} from '@app/add-product/models/variant-grid-data-model';
import { HttpErrorResponse, HttpEventType } from '@angular/common/http';
import { AppToastrService } from '@app/@core/services/toastr/app-toastr.service';
import {
    IImageUploadSuccess,
    IImageUploadSuccessResponse,
} from '@app/@shared/Models/form-data.model';
import { BehaviorSubject } from 'rxjs';
import { retry } from 'rxjs/operators';

@Component({
    selector: 'sp-upload-images-dialog',
    templateUrl: './upload-images-dialog.component.html',
    styleUrls: ['./upload-images-dialog.component.scss'],
    animations: [
        trigger('fadeInOut', [
            state('in', style({ opacity: 100 })),
            transition('* => void', [animate(300, style({ opacity: 0 }))]),
        ]),
    ],
})
export class UploadImagesDialogComponent implements OnInit {
    inputImages: Array<ISetVariantsImage> = [];
    maxUploadedCnt: number = 6;
    @Output() complete = new EventEmitter<string>();
    uploadedVaraintImages: Array<ISetVariantsImage> = [];
    public enableSpinner$ = new BehaviorSubject(false);
    onGoingRequestsCnt: number = 0;

    constructor(
        public setService: SetsService,
        private toasterService: AppToastrService,
        private dialogRef: MatDialogRef<UploadImagesDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        public variantImageModalData: IVariantImageModelData
    ) {}

    ngOnInit(): void {
        if (
            this.setService.selectedVaraintsList[
                this.variantImageModalData.currentVariantIndex
            ].variantImages
        )
            this.uploadedVaraintImages =
                this.setService.selectedVaraintsList[
                    this.variantImageModalData.currentVariantIndex
                ].variantImages;
        this.maxUploadedCnt = 6 - this.uploadedVaraintImages.length;
    }

    close() {
        this.dialogRef.close();
    }

    private maxUploadCheck(noOfFiles: number): boolean | void {
        if (noOfFiles > this.maxUploadedCnt) {
            alert(`Maximum ${this.maxUploadedCnt} images can be uploaded.`);
            return true;
        }
    }

    onDrop(event: DragEvent): void {
        event.preventDefault();
        const files = event.dataTransfer?.files;
        if (this.maxUploadCheck(files.length)) {
            return;
        }
        this.onGoingRequestsCnt = files.length;
        this.enableSpinner$.next(true);
        for (let index = 0; index < files.length; index++) {
            const file = files[index];
            this.inputImages.push({
                file: file,
                state: 'in',
                progress: 0,
                isuploaded: false,
                previewUrl: '',
            });
        }
        this.uploadFiles();
    }

    onDragOver(event: DragEvent) {
        event.preventDefault();
    }

    onClick(event: KeyboardEvent): void {
        event.preventDefault()
        const fileUpload = document.getElementById(
            'fileUpload'
        ) as HTMLInputElement;
        fileUpload.onchange = () => {
            if (this.maxUploadCheck(fileUpload.files.length)) {
                return;
            }
            this.onGoingRequestsCnt = fileUpload.files.length;
            this.enableSpinner$.next(true);
            for (let index = 0; index < fileUpload.files.length; index++) {
                const file = fileUpload.files[index];
                this.inputImages.push({
                    file: file,
                    state: 'in',
                    progress: 0,
                    isuploaded: false,
                    previewUrl: '',
                });
            }
            this.uploadFiles();
        };
        fileUpload.click();
    }

    private uploadFile(index: number): void {
        const formData = new FormData();
        if (this.checkFileSize(this.inputImages[index].file)) {
            formData.append('file', this.inputImages[index].file);

            this.setService
                .uploadImageWithProgress(formData)
                .pipe(retry(3))
                .subscribe(
                    (event) => {
                        if (event.type === HttpEventType.UploadProgress) {
                            const progress: number = Math.round(
                                (100 * event.loaded) / event.total
                            );
                            this.inputImages[index].progress = progress;
                        } else if (event.type === HttpEventType.Response) {
                            const successResponse: IImageUploadSuccessResponse<IImageUploadSuccess> =
                                event.body;
                            if (successResponse.data.id) {
                                this.inputImages[index].isuploaded = true;
                                this.inputImages[index].previewUrl =
                                    successResponse.data.id;
                                this.onGoingRequestsCnt--;
                            }
                            if (!this.onGoingRequestsCnt)
                                this.enableSpinner$.next(false);
                        }
                    },
                    (resErr) => {
                        this.inputImages.splice(index, 1);
                        this.onGoingRequestsCnt--;
                        if (!this.onGoingRequestsCnt)
                            this.enableSpinner$.next(false);
                    }
                );
        } else {
            this.toasterService.error(
                'File size too large, kindly upload image below 5MB'
            );
            this.inputImages.splice(index, 1);
        }
    }

    private checkFileSize(input: File) {
        const maxSizeInMB = 5;
        const fileSize = input.size / (1024 * 1024);
        return fileSize < maxSizeInMB;
    }

    private uploadFiles(): void {
        const fileUpload = document.getElementById(
            'fileUpload'
        ) as HTMLInputElement;
        fileUpload.value = '';

        this.inputImages.forEach((image, i) => {
            this.uploadFile(i);
        });
    }
    uploadImages(): void {
        this.setService.selectedVaraintsList[
            this.variantImageModalData.currentVariantIndex
        ].variantImages = [...this.uploadedVaraintImages, ...this.inputImages];
        this.setService.selectedVaraintsList = [
            ...this.setService.selectedVaraintsList,
        ];
        console.log(this.setService.selectedVaraintsList);
        this.dialogRef.close();
    }

    deleteFile(index: number): void {
        this.inputImages.splice(index, 1);
    }
    sumOfQuantity(bundleIndex: number): number {
        return this.setService.selectedVaraintsList[
            bundleIndex
        ].variants.reduce(
            (acc: number, variantGridData: IVariantGridData) =>
                acc + +variantGridData.quantity,
            0
        );
    }
}
